import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import PropTypes from "prop-types"
import * as authors from "../../data/authors"

const StyledCardArticle = styled.article`
  display: flex;
  flex-direction: column;
  background-color: #151515;
  color: #fff;
  margin-bottom: 32px;
  border-radius: 8px;
  @media (min-width: 768px) {
    min-height: 100%;
    margin-bottom: 0;
  }
  h3 {
    padding: 0 19px 0 13px;
    margin-top: 0;
    margin-bottom: 16px;
    font-family: "Made Evo Bold", sans-serif;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.3px;
    @media (min-width: 768px) {
      padding: 0 30px;
    }
  }
`

const Desc = styled.p`
  padding: 0 19px 16px 13px;
  @media (min-width: 768px) {
    padding: 0 30px 20px;
  }
`

const StyledImg = styled(Img)`
  height: 110px;
  border-radius: 8px 8px 0 0;
  @media (min-width: 768px) {
    height: 270px;
  }
`

const Container = styled.div`
  display: flex;
  padding: 0 19px 0 13px;
  transform: translateY(-24px);
  margin-bottom: -8px;
  @media (min-width: 768px) {
    transform: translateY(-36px);
    margin-bottom: -16px;
  }
  & img {
    background-color: #f9d6c1;
    width: 48px;
    height: 48px;
    border: 2px solid #000;
    border-radius: 50%;
    @media (min-width: 768px) {
      width: 72px;
      height: 72px;
    }
  }
  & p {
    align-self: flex-end;
    margin-left: 12px;
    line-height: 15px;
    text-decoration: none;
    @media (min-width: 768px) {
      margin-left: 16px;
    }
    &:first-child {
      font-family: "Made Medium", sans-serif;
      letter-spacing: 0.4px;
      font-size: 16px;
    }
    &:last-child {
      font-size: 12px;
      letter-spacing: 0.3px;
      color: #808080;
    }
  }
`

const StyledLink = styled(Link)`
  @media (min-width: 768px) {
    transition: transform 0.2s ease;
    &:hover {
      transform: scale(1.02);
    }
    &.first-article {
      grid-column: 1 / 3;
      ${StyledImg} {
        height: 370px;
      }
      ${StyledCardArticle} {
        height: 540px;
        h3 {
          padding: 0 40px;
        }
      }
      ${Desc} {
        padding: 0 40px 25px;
      }
      ${Container} {
        padding: 0 40px;
      }
    }
  }
`

const BlogPostPreview = ({
  slug,
  featuredimage,
  title,
  firstArticle,
  date,
  author,
  description,
}) => {
  const allAuthorsArr = Object.values(authors)
  const authorData = allAuthorsArr.filter(item => item.authorName.includes(author))
  const { avatar, authorName } = authorData[0]

  return (
    <StyledLink
      to={slug}
      style={{ textDecoration: "none" }}
      className={firstArticle && "first-article"}
    >
      <StyledCardArticle>
        <StyledImg fluid={featuredimage.childImageSharp.fluid} fadeIn />
        <Container>
          <img src={avatar} alt={authorName} title={authorName} />
          <p>{authorName}</p>
          <p>{date}</p>
        </Container>
        <h3>{title}</h3>
        <Desc>{description}</Desc>
      </StyledCardArticle>
    </StyledLink>
  )
}

export default BlogPostPreview

BlogPostPreview.propTypes = {
  slug: PropTypes.string.isRequired,
  firstArticle: PropTypes.bool,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  featuredimage: PropTypes.oneOfType([PropTypes.object]).isRequired,
}

BlogPostPreview.defaultProps = {
  firstArticle: false,
}
